/* Native anchors and popovers work without JavaScript. The custom element
   also reconnects safely when Shopify reloads the section in the theme editor. */
if (!customElements.get('loyal-anniversary')) {
  customElements.define('loyal-anniversary', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.nav = this.querySelector('.anniversary__nav');
      this.links = [...this.nav.querySelectorAll('a')];
      this.sections = [...this.querySelectorAll('.anniversary__section')];

      // Keep details beside their trigger without affecting the card's layout.
      // Native popovers handle outside clicks, Escape, and focus restoration.
      this.popovers = [...this.querySelectorAll('.anniversary__popover')];
      const positionPopover = (panel) => {
        const trigger = panel.parentElement.querySelector('.anniversary__details-trigger');
        const rect = trigger.getBoundingClientRect();
        const width = panel.offsetWidth;
        const height = panel.offsetHeight;
        const viewportHeight = document.documentElement.clientHeight;
        const viewportWidth = document.documentElement.clientWidth;
        const below = rect.bottom + 8;
        const above = rect.top - height - 8;
        const top = below + height <= viewportHeight - 16 ? below : above;
        Object.assign(panel.style, {
          margin: '0', right: 'auto', bottom: 'auto',
          left: `${Math.max(16, Math.min(rect.left, viewportWidth - width - 16))}px`,
          top: `${Math.max(16, Math.min(top, viewportHeight - height - 16))}px`
        });
      };
      if ('showPopover' in HTMLElement.prototype) {
        this.popovers.forEach(panel => {
          panel.addEventListener('beforetoggle', event => {
            if (event.newState === 'open') requestAnimationFrame(() => {
              if (panel.isConnected && panel.matches(':popover-open')) positionPopover(panel);
            });
          }, { signal });
        });
        const reposition = () => this.popovers.forEach(panel => {
          if (panel.matches(':popover-open')) positionPopover(panel);
        });
        window.addEventListener('resize', reposition, { passive: true, signal });
        window.addEventListener('scroll', reposition, { passive: true, signal });
      }

      this.addEventListener('click', (event) => {
        const link = event.target.closest('a[href^="#"]');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = [...this.sections, this.querySelector('#event'), this.querySelector('#locations')].find(section => section && `#${section.id}` === link.hash);
        if (!target) return;
        event.preventDefault();
        history.pushState(null, '', link.hash);
        target.focus({ preventScroll: true });
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, { signal });

      const scheduleUpdate = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const offset = this.nav.getBoundingClientRect().height + 40;
          let active = this.sections[0];
          this.sections.forEach(section => {
            if (section.getBoundingClientRect().top <= offset) active = section;
          });
          this.links.forEach(link => {
            if (link.hash === `#${active.id}`) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
        });
      };
      window.addEventListener('scroll', scheduleUpdate, { passive: true, signal });
      window.addEventListener('resize', scheduleUpdate, { signal });
      scheduleUpdate();
    }

    disconnectedCallback() {
      this.controller.abort();
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}
